export default __webpack_public_path__ + "static/media/latribu-hr-white.60e58f4b.svg";